export const blackscreenInit = () => {
    const bs = document.querySelector(".Blackscreen")
    const logo = bs.querySelector("figure.logo")
    let height = { min: document.querySelector(".Getheight.svh").getBoundingClientRect().height, max: document.querySelector(".Getheight.lvh").getBoundingClientRect().height }
    const defRange = 10
    let range = Math.max((height.max - height.min), defRange);
    // console.log([height, range])

    let state = { prev: 0, crnt: 0 }
    let logoOT = logo.offsetTop
    let logoOH = logo.offsetHeight
    let logoMargin = [parseInt(getComputedStyle(logo).marginTop), parseInt(getComputedStyle(logo).marginBottom)]
    let offset = 0
    let heightOffset = 0

    if (document.body.classList.contains("recruit")) {
        offset = parseInt(getComputedStyle(bs).paddingTop) + parseInt(getComputedStyle(logo).marginTop)
        heightOffset = document.querySelector(".mv").offsetHeight + parseInt(getComputedStyle(bs).marginTop) + parseInt(getComputedStyle(bs).paddingTop)
    }

    if (logo) {
        logomover()

        requestAnimationFrame(() => {
            logomover()
        })

        let timeoutId = 0;

        window.addEventListener('resize', () => {
            if (timeoutId) clearTimeout(timeoutId);

            timeoutId = setTimeout(resize, 200);
        });

        function resize() {
            height = { min: document.querySelector(".Getheight.svh").getBoundingClientRect().height, max: document.querySelector(".Getheight.lvh").getBoundingClientRect().height }
            logoMargin = [parseInt(getComputedStyle(logo).marginTop), parseInt(getComputedStyle(logo).marginBottom)]

            range = Math.max((height.max - height.min), defRange)
            logoOT = logo.offsetTop
            logoOH = logo.offsetHeight
        }

        function logomover() {

            //ios safariでresize時にlogo.getBoundingClientRect().topがふざけるので分ける
            if (innerWidth > 1024) {
                const logoInfo = logo.getBoundingClientRect()
                let loc = logoInfo.top + logoInfo.height / 2,
                    halfHeight = height.min / 2
                if (loc <= halfHeight + defRange && loc >= halfHeight - range) {
                    state.crnt = 1
                    logo.style.opacity = 1
                    logo.style.filter = ""
                } else if (loc > halfHeight) {
                    // console.log(["elseif", loc, halfHeight, halfHeight + range * 2])
                    state.crnt = 2
                    logo.style.opacity = 0
                    logo.style.filter = ""
                } else {
                    state.crnt = 3
                    logo.style.opacity = 1
                    logo.style.filter = "none"
                }

                if (state.prev != state.crnt) {
                    // console.dir({ state: state.crnt, logo: { loc: loc, top: logoInfo.top, height: logoInfo.height }, halfHeight: halfHeight, innerHeight, performance: performance.now() }, { depth: -1 })
                    state.prev = state.crnt
                }
            } else {
                logoOT = logo.offsetTop - offset

                let decisionHeight = ((document.body.clientHeight - heightOffset - (logoOH + logoMargin[0] + logoMargin[1]) - 5))
                if (logoOT >= decisionHeight) {
                    state.crnt = 3
                    logo.style.opacity = 1
                    logo.style.filter = "none"
                } else if (logoOT == 0) {
                    // console.log(["elseif", loc, halfHeight, halfHeight + range * 2])
                    state.crnt = 2
                    logo.style.opacity = 0
                    logo.style.filter = ""
                } else {
                    state.crnt = 1
                    logo.style.opacity = 1
                    logo.style.filter = ""
                }

                if (state.prev != state.crnt) {
                    // console.dir({ state: state.crnt, logo: { top: logoOT, height: logoOH }, halfHeight: halfHeight, innerHeight, performance: performance.now() }, { depth: -1 })
                    state.prev = state.crnt
                }
            }

            // document.querySelector(".debug p").innerHTML = JSON.stringify({ state: state.crnt, logo: { top: logoOT, height: logoOH }, decisionHeight })

            requestAnimationFrame(() => {
                logomover()
            })
        }
    }
}